/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";
import ODataStore from "devextreme/data/odata/store";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RoamDespatchOrderListService = {
  async getByCode(code) {
    const requestScreenData = {
      url: "api/PickingSlip",
      top: "1",
      filter: `SalesOrderCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getByConsignmentNo(consignmentNo, select) {
    const requestScreenData = {
      url: "api/PickingSlip",
      // top: "1",
      filter: `ConsignmentNo eq '${consignmentNo}' and Status eq 'A'`,
    };

    if (select) requestScreenData.select = select;

    return await ApiService.oDataGet(requestScreenData);
  },
  async savePickingSlipStartTime(payload) {
    var url = "api/Save_PickingSlipStartTime";
    await ApiService.post(url, payload);
  },
  dataSourceConfig(params) {
    var url = "api/PickingSlipDetail";
    return ApiService.createDataSource(url, params);
  },
  async saveRoamDespatchOrder(payload) {
    var url = "api/Save_RoamPickingSlip";
    await ApiService.post(url, payload);
  },
};

export { RoamDespatchOrderListService };
